module.exports = __webpack_public_path__ + "static/media/spei.1b0e7c35.svg";